import { connectWallet } from "api/api";

export const connectResponse = async () => {
  const type = event.detail.type;
  const payload = event.detail.payload;

  switch (type) {
    case "RESPONSE_HAS_ACCOUNT":
      return { type: "check-account", data: payload };

    case "RESPONSE_HAS_ADDRESS":
      return { type: "check-address", data: payload };

    case "CANCEL_JSON-RPC":
      return { type: "cancel", data: payload };

    case "RESPONSE_SIGNING":
      return { type: "signIn", data: payload };

    case "RESPONSE_ADDRESS":
      return { type: "address", data: payload };

    case "RESPONSE_JSON-RPC":
      return { type: "json-RPC", data: payload };

    default:
      return { type: "default", data: payload };
  }
};
